import React from 'react';
import { NavLink } from 'react-router-dom';
import { Button } from '../../atoms/Button/Button';
import { useAuth } from '../../../features/auth/application/useAuth';
import { MdPeople, MdWhatsapp, MdLogout } from 'react-icons/md';
import styles from './DashboardLayout.module.css';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
    const { logout } = useAuth();
    const logoPath = process.env.REACT_APP_LOGO_PATH || "/assets/alejandro/logo.png";
    const candidateName = process.env.REACT_APP_CANDIDATE_NAME || "Candidato";

    return (
        <div className={styles.dashboardContainer}>
      <aside className={styles.sidebar}>
        <div className={styles.logoContainer}>
          {/* Puedes reemplazar este h2 por el logo de tu aplicación */}
         <img src={logoPath} alt={candidateName} className="h-16" />
        </div>

        <nav className={styles.menu}>
          {/* Usamos NavLink para que los enlaces activos tengan un estilo especial */}
          <NavLink 
            to="/dashboard" 
            className={({ isActive }) => isActive ? `${styles.menuItem} ${styles.active}` : styles.menuItem}
          >
            <MdPeople className="inline mr-2" size={20} />
            <span>Usuarios</span>
          </NavLink>
          <NavLink 
            to="/manage-whatsapp" 
            className={({ isActive }) => isActive ? `${styles.menuItem} ${styles.active}` : styles.menuItem}
          >
            <MdWhatsapp className="inline mr-2" size={20} />
            <span>Grupos de Whatsapp</span>
          </NavLink>
        </nav>

        <div className={styles.logoutContainer}>
          <Button onClick={logout} type="button" className={styles.logoutButton}>
            <MdLogout className="inline mr-2" size={20} />
            Cerrar Sesión
          </Button>
        </div>
      </aside>
      <main className={styles.content}>
        {children}
      </main>
    </div>
    );
};
